import React from "react";
import { boostCampaignHelper } from "@/features/campaigns/digital/boost-campaign/utils/boostCampaignHelper";
import { Grid as GridBase, Paper, Typography } from "@mui/material";
import { CurrencyFormateText } from "@/components/CurrencyFormat";
import type { BoostSelection } from "./BoostConfirmLocation";

type BoostConfirmTotalProps = {
  selections?: BoostSelection[];
};

const Grid = GridBase as React.ComponentType<Record<string, any>>;

function BoostConfirmTotal({ selections }: BoostConfirmTotalProps) {
  const total = boostCampaignHelper.getBoostTotal(selections);

  return (
    <Paper className="my-4 px-2 py-3 boost-confirm-total" elevation={2}>
      <Grid container spacing={2}>
        <Grid item size={{ xs: 12, md: 5, lg: 6 }}></Grid>
        <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 3 }}>
          <Typography
            color="text.primary"
            variant="h6"
            className="text-center text-sm-right"
          >
            Total Adjusted Budget:
          </Typography>
        </Grid>
        <Grid item size={{ xs: 12, sm: 6, md: 3, lg: 3, xl: 2 }}>
          <Typography
            color="text.primary"
            variant="h6"
            className="total-boost-budget"
          >
            <CurrencyFormateText value={total} suffix=" USD" />
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default BoostConfirmTotal;
